import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export type ProgramRequestAttributesResponse = {
  pairs: { key: string; values: string[] }[]
}
export type ProgramRequestAttributesKeysResponse = string[]

export function useGetRequestAttributes(programId?: string) {
  return useQuery({
    queryKey: ['request-attributes', programId],
    queryFn: async () => {
      const { data } = await apiClient.get<ProgramRequestAttributesResponse>(
        `/int/v3/programs/${programId}/request-attributes`
      )
      return data.pairs.reduce(
        (acc, { key, values }) => {
          acc.optionsLeft.push(key)
          acc.optionsRight.push(values)
          return acc
        },
        {
          optionsLeft: [] as string[],
          optionsRight: [] as string[][],
        }
      )
    },
    enabled: Boolean(programId),
  })
}

export function useGetRequestAttributesKeys(programId?: string) {
  return useQuery({
    queryKey: ['request-attributes-keys', programId],
    queryFn: async () => {
      const { data } = await apiClient.get<ProgramRequestAttributesKeysResponse>(
        `/int/v3/programs/${programId}/request-attributes-keys`
      )
      return data.keys
    },
    enabled: Boolean(programId),
  })
}
